<template>
  <div class="my-layout-app">
    <Header />
    <app-main :class="page.isHeaderShow ? 'my-layout-appMain' : 'my-no-header-appMain'" />
    <Footer v-if="!page.noFooter" class="my-layout-footer" />
  </div>
</template>
<script>
import { AppMain, Footer, Header } from "./Components";
import { mapGetters } from "vuex";

export default {
  name: "LayOut",
  components: {
    Header,
    Footer,
    AppMain
  },
  computed: {
    ...mapGetters(["page"])
  }
};
</script>
<style lang="less" scoped>
.my-layout-app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .my-layout-appMain {
    box-sizing: border-box;
    padding-top: 46px;
    padding-bottom: 50px;
    flex: 1;
  }

  .my-no-header-appMain {
    box-sizing: border-box;
    padding-bottom: 50px;
    flex: 1;
    padding-top: 0;
  }
}
</style>
